
import React from 'react';
import { AuthenticatedRoute } from './routes/AuthenticatedRoute';

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  return <AuthenticatedRoute>{children}</AuthenticatedRoute>;
};

// Export as default as well for backward compatibility
export default ProtectedRoute;
